// PKCE helpers (RFC 7636), for the DS Core login

// base64 with + → -, / → _ and no trailing = (RFC 7636 §3)
export const base64url = (bytes: Uint8Array): string =>
  btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");

// 32 random bytes → 43 characters, the minimum length RFC 7636 allows
export const generateCodeVerifier = (): string =>
  base64url(crypto.getRandomValues(new Uint8Array(32)));

export const generateState = (): string =>
  base64url(crypto.getRandomValues(new Uint8Array(16)));

export const getCodeChallenge = async (
  codeVerifier: string
): Promise<string> => {
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(codeVerifier)
  );
  return base64url(new Uint8Array(digest));
};
